// Sep 2026 — Dark-Mode-Simulation für die Admin-E-Mail-Vorschau (kein echter Client, aber nah dran)
export const PREVIEW_MODES = [
  { id: 'light', label: 'Hell' },
  { id: 'apple', label: 'Dunkel · Apple Mail' },
  { id: 'outlook', label: 'Dunkel · Outlook' },
];

const OUTLOOK_CLIENT_CSS = `
<style data-sim="outlook">
  body { background: #1f1f1f; color: #e8e8e8; }
  p, div, td, th, h1, h2, h3, li, span, strong, b, a { color: #e8e8e8; }
  .content, .header, .email-container, .info, .footer, .invoice-info,
  div[style*="background:#fff"], div[style*="background: #fff"], div[style*="background:#ffffff"] { background: #2b2b2b; }
</style>`;

// Apple/iOS Mail: prefers-color-scheme:dark greift → Media-Query auf "all" umschreiben, Seitenhintergrund dunkel
function simulateApple(html) {
  return html
    .replace(/@media\s*\(prefers-color-scheme:\s*dark\)/gi, '@media all')
    .replace('</head>', '<style data-sim="apple">html { background: #000; }</style></head>');
}

// Outlook: Client legt data-ogsc/data-ogsb auf einen Wrapper und färbt Text/Hintergründe um
function simulateOutlook(html) {
  const withCss = html.replace('</head>', `${OUTLOOK_CLIENT_CSS}</head>`);
  return withCss
    .replace(/<body([^>]*)>/i, '<body$1><div data-ogsc="1" data-ogsb="1">')
    .replace(/<\/body>/i, '</div></body>');
}

export function simulateDarkMode(html, mode) {
  if (!html || mode === 'light') return html;
  return mode === 'apple' ? simulateApple(html) : simulateOutlook(html);
}
